import { transform as olTransform } from 'ol/proj';
import { saveAs } from 'file-saver';
import { SimpleGeometry } from 'ol/geom';
import Feature from 'ol/Feature';

export const KmlExport = {
    // Returns KML file of given features
    getFile: function (features: Feature[]) {
        const coordsNE: Coordinate[][][] = features.map(f => (f.getGeometry() as SimpleGeometry).getCoordinates());

        const drawings = coordsNE.map(coord => {
            return coord.map(outline => {
                return outline.map(point => {
                    const transformed = olTransform(point, 'EPSG:3857', 'EPSG:4326');
                    const lon = transformed[0];
                    const lat = transformed[1];
                    const height = Array.isArray(point) && point.length > 2 && typeof point[2] === 'number' ? point[2] : 0;
                    return [lon, lat, height];
                });
            });
        });

        const kml = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
\t<Document>
\t\t<name>Infrakit map area drawings</name>
\t\t<Style id="normal-style">
\t\t\t<LineStyle>
\t\t\t\t<color>ff000000</color>
\t\t\t\t<width>1.2</width>
\t\t\t</LineStyle>
\t\t\t<PolyStyle>
\t\t\t\t<color>4d000000</color>
\t\t\t\t<fill>1</fill>
\t\t\t\t<outline>1</outline>
\t\t\t</PolyStyle>
\t\t\t<BalloonStyle>
\t\t\t\t<text><![CDATA[<h3>$[name]</h3>]]></text>
\t\t\t</BalloonStyle>
\t\t</Style>
\t\t<StyleMap id="style-map">
\t\t\t<Pair>
\t\t\t\t<key>normal</key>
\t\t\t\t<styleUrl>#normal-style</styleUrl>
\t\t\t</Pair>
\t\t</StyleMap>
\t\t${drawings
            .map((drawing, i) => {
                return `<Placemark>
\t\t\t<name>Area ${i + 1}</name>
\t\t\t<styleUrl>#style-map</styleUrl>
\t\t\t<Polygon>
\t\t\t\t<outerBoundaryIs>
\t\t\t\t\t<LinearRing>
\t\t\t\t\t\t<coordinates>
\t\t\t\t\t\t\t${drawing.map(coords => {
                    return coords.map(triple => triple.slice(0, 3).join(',')).join('\n\t\t\t\t\t\t\t');
                })}
\t\t\t\t\t\t</coordinates>
\t\t\t\t\t</LinearRing>
\t\t\t\t</outerBoundaryIs>
\t\t\t</Polygon>
\t\t</Placemark>`;
            })
            .join('\n\t\t')}
\t</Document>
</kml>`;
        return new Blob([kml], { type: 'text/kml;charset=utf-8' });
    },

    // Saves KML file of selected features
    export: function (features: Feature[]) {
        const file = this.getFile(features);
        saveAs(file, 'infrakit_area_drawings.kml');
    },
};
